import React from 'react'
import { createRoot } from 'react-dom/client'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { ThemeProvider } from '@mui/material/styles'
import * as Sentry from '@sentry/react'
import { Integrations } from '@sentry/tracing'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { Buffer } from 'buffer';
import { RELEASE_ENV, SENTRY_DSN } from 'common/env'
import store from 'common/store'
import GlobalStyle from 'styles/GlobalStyle'
import theme from 'styles/theme'
import Router from './Router'


if (RELEASE_ENV !== 'development') {
  if (SENTRY_DSN) {
    Sentry.init({
      dsn: SENTRY_DSN,
      environment: RELEASE_ENV,
      integrations: [new Integrations.BrowserTracing()],
    })
  }
}

global.Buffer = Buffer;

const container = document.getElementById('root');

const root = createRoot(container);

root.render(
  <ThemeProvider theme={theme}>
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <GlobalStyle />
      <Provider store={store}>
        <BrowserRouter>
          <Router />
        </BrowserRouter>
      </Provider>
    </LocalizationProvider>
  </ThemeProvider>
)
